import React, { useState, useEffect } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import axios from 'axios';

// Composant qui fournit le contexte Stripe à l'application
const StripeProvider = ({ children }) => {
  const [stripePromise, setStripePromise] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Récupérer la clé publique Stripe depuis le serveur
    const getStripeKey = async () => {
      try {
        const response = await axios.get('/api/stripe/config');
        const publishableKey = response.data.publishableKey;
        
        // Initialiser Stripe avec la clé publique
        const stripeInstance = loadStripe(publishableKey);
        setStripePromise(stripeInstance);
      } catch (error) {
        console.error('Erreur lors de la récupération de la clé Stripe:', error);
      } finally {
        setLoading(false);
      }
    };

    getStripeKey();
  }, []);

  if (loading) {
    return <div className="text-center mt-5"><div className="spinner-border" role="status"></div></div>;
  }

  return (
    <Elements stripe={stripePromise}>
      {children}
    </Elements>
  );
};

export default StripeProvider;
